module.exports = __webpack_public_path__ + "img/casco.b268c766.png";